import React from "react";
import styles from "./chatnodatafound.module.scss";
import chatnodata from "../../styles/images/chaterror.svg";

function ChatNoDataFound() {
  return (
    <>
      <div className={styles.nodatafound}>
        <div className={styles.nodataimg}>
          <img className={styles.lefticon} src={chatnodata} alt="" />
        </div>
      </div>
    </>
  );
};

export default ChatNoDataFound;
